import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import RoleInformation from './RoleInformation';
import useCreateNewRole from './hooks/useCreateNewRole';
import Permissions from './Permissions';
import { PermissionCategoryContext } from './PermissionCategoryContext';
import Footer from '../../Common/Footer';
import { withBreadcrumbs } from '../../Routing/Breadcrumbs';
import { RNPToastComponent } from '../RNPToaster';
import { RNPTabs } from '../../../pages/RolesAndPermissions/types';
import Loading from '../../Loading';
import { CREATE_ROLE, SAVE_CHANGES } from '../../../utils/constants';

const StyledContainer = styled.div`
  border-radius: 8px;
  background-color: white;
`;

const StyledLoadingContainer = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  pageToEdit?: RNPTabs;
};

const CreateNewRole = ({ pageToEdit }: Props) => {
  const isEditView = !!pageToEdit;

  const {
    loading,
    organisations,
    permissionCategoryData,
    isViewOnlyRole,
    formData: {
      roleDescription,
      roleName,
      selectedOrganisation,
      onRoleDescriptionChange,
      onRoleNameChange,
      onSelectedOrganisationChange,
      getIsFormValid,
      onCancel,
      onCreateRole,
    },
  } = useCreateNewRole({ pageToEdit, isEdit: isEditView });

  return (
    <StyledContainer>
      <Header isEdit={isEditView} isViewOnlyRole={isViewOnlyRole} />
      {isEditView && loading ? (
        <StyledLoadingContainer>
          <Loading />
        </StyledLoadingContainer>
      ) : (
        <React.Fragment>
          <RoleInformation
            isEdit={isEditView}
            organisations={organisations}
            roleDescription={roleDescription}
            roleName={roleName}
            selectedOrganisation={selectedOrganisation}
            onRoleDescriptionChange={onRoleDescriptionChange}
            onRoleNameChange={onRoleNameChange}
            onSelectedOrganisationChange={onSelectedOrganisationChange}
          />
          <PermissionCategoryContext.Provider
            value={{ ...permissionCategoryData, isEdit: isEditView }}
          >
            <Permissions />
          </PermissionCategoryContext.Provider>
        </React.Fragment>
      )}
      <Footer
        submitButtonText={isEditView ? SAVE_CHANGES : CREATE_ROLE}
        isSubmitDisabled={!getIsFormValid() || isViewOnlyRole}
        onCancel={onCancel}
        onSubmit={onCreateRole}
      />
      <RNPToastComponent />
    </StyledContainer>
  );
};

export default withBreadcrumbs(CreateNewRole);
